import loc from 'owa-localize';
import { selectSubcategory } from 'owa-options-orchestration';
import { getStore, getCurrentCategory } from 'owa-options-store';
import { observer } from 'mobx-react-lite';
import { BaseButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { OptionSubCategory, OptionCategory } from 'owa-options-core';
import * as React from 'react';
import { AnimationClassNames } from '@uifabric/styling';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { ControlIcons } from 'owa-control-icons';
import { useOptionLayout, OptionLayout } from './hooks/useOptionLayout';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface OptionEntryProps {
    subcategory: OptionSubCategory;
    onSubCategorySelect?(subcategory: OptionSubCategory): void;
}

export const SubCategoryEntry = observer(function SubCategoryEntry({
    subcategory,
    onSubCategorySelect,
}: OptionEntryProps) {
    let buttonStyles = {
        root: className(styles.option, {
            selectedOption: getStore().currentSubCategoryKey === subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };
    const onClick = React.useCallback(
        () => (onSubCategorySelect || selectSubcategory)(subcategory),
        [subcategory, onSubCategorySelect]
    );
    return (
        <BaseButton
            styles={buttonStyles}
            key={subcategory.key}
            onClick={onClick}
            text={loc(subcategory.titleStringKey) as string}
            role="tab"
        />
    );
});

export interface SubcategoriesColumnProps {
    category?: OptionCategory;
    onSubCategorySelect?(subcategory: OptionSubCategory): void;
    onNavigateBack?(): void;
}
export const SubCategoriesColumn = observer(function SubCategoriesColumn({
    category: { subcategories, titleStringKey: categoryTitleStringKey } = getCurrentCategory(),
    onSubCategorySelect,
    onNavigateBack,
}: SubcategoriesColumnProps) {
    const layout = useOptionLayout();
    return (
        <div
            className={className(
                styles.optionsColumn,
                layout !== OptionLayout.ThreeColumn && AnimationClassNames.slideRightIn20,
                layout !== OptionLayout.ThreeColumn && styles.dropShadow
            )}
            role="tablist">
            {onNavigateBack && (
                <div className={styles.settingsHeader}>
                    <div className={styles.settingsTitle} role="heading">
                        <IconButton
                            iconProps={{
                                iconName: ControlIcons.Back,
                            }}
                            className={styles.iconButton}
                            onClick={onNavigateBack}
                        />
                        <div>{loc(categoryTitleStringKey)} </div>
                    </div>
                </div>
            )}
            <FocusZone
                direction={FocusZoneDirection.vertical}
                key={getStore().currentCategoryKey}
                className={className(
                    layout === OptionLayout.ThreeColumn && AnimationClassNames.slideLeftIn20,
                    styles.subcategoryList
                )}>
                {subcategories.map(subcategory => (
                    <SubCategoryEntry
                        subcategory={subcategory}
                        key={subcategory.key}
                        onSubCategorySelect={onSubCategorySelect}
                    />
                ))}
            </FocusZone>
        </div>
    );
});
